module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "block block-blue"
  }, [_c('div', {
    staticClass: "home-block group group--first-last-small"
  }, _vm._l((_vm.content), function(block, index) {
    return _c('span', {
      key: index,
      staticClass: "mt-2"
    }, [_c('h3', {
      staticClass: "h3"
    }, [_vm._v(_vm._s(block.title))]), _vm._v(" "), _c('p', {
      staticClass: "p mw-100"
    }, [_vm._v(_vm._s(block.body))])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4570d4cc"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/pages/understandingYourReport/BlueCallToAction.vue
// module id = 309
// module chunks = 0